import type {
  HotelIngredient,
  RecipeIngredient,
  OwnTransportIngredient,
} from '@apps/main/modules/recipe/ingredients';

import type { RouteWithDetails } from '@libs/maps';
import type {
  HotelIngredientResponseWithStaticInfo,
  OwnStayIngredientResponseWithStaticInfo,
  OwnTransportIngredientResponseWithStaticInfo,
} from '@libs/trip-planner-interfaces';
import { TransportType } from '@libs/trip-planner-interfaces';
import { isOwnTransportIngredientResponseWithStaticInfo } from '@libs/search-service-smart-search';

import type { ItineraryOwnTransportSegment } from '../../models';

import {
  getTripOverviewNoTransportSegment,
  getTripOverviewSimpleTransportSegment,
} from './tripOverviewSimpleTransportSegmentsLogic';

export function getOwnTransportRelatedSegment(
  ingredient: OwnTransportIngredientResponseWithStaticInfo,
  hotelRelatedIngredient:
    | HotelIngredientResponseWithStaticInfo
    | OwnStayIngredientResponseWithStaticInfo
    | HotelIngredient,
  ingredientIndex: number,
  getIngredient: (id: string) => RecipeIngredient,
  calculatedRoute: RouteWithDetails,
  shoudAddTransport: boolean,
  isUserFromBookingPage: boolean,
  hasUserSelectedTransport: boolean,
  isLastSegment: boolean,
  previousIngredientDestination?: string
): ItineraryOwnTransportSegment | undefined {
  if (!isOwnTransportIngredientResponseWithStaticInfo(ingredient)) {
    return;
  }

  const ownTransportIngredient = getIngredient(
    ingredient.ingredientId
  ) as OwnTransportIngredient;
  const isStaticInfoStayIngredient = 'staticInfo' in hotelRelatedIngredient;
  let hotelIngredient: HotelIngredient | undefined;
  if (isStaticInfoStayIngredient) {
    hotelIngredient = getIngredient(
      hotelRelatedIngredient.ingredientId
    ) as HotelIngredient;
  }

  function hasDisplayText(
    ingredient:
      | HotelIngredientResponseWithStaticInfo
      | OwnStayIngredientResponseWithStaticInfo
      | HotelIngredient
  ): ingredient is HotelIngredient {
    return 'displayText' in ingredient;
  }

  if (shoudAddTransport) {
    const mainPolygonFullName = isStaticInfoStayIngredient
      ? hotelRelatedIngredient.staticInfo?.mainPolygon?.fullName
      : undefined;
    const transportSegment =
      ownTransportIngredient.ownTransportType === TransportType.None
        ? getTripOverviewNoTransportSegment({
            ingredientId: ingredient.ingredientId,
            ingredientIndex,
            isReturnTransport: isLastSegment,
            isLastSegment: isLastSegment,
            isUserFromBookingPage,
            displayText:
              isStaticInfoStayIngredient && hotelIngredient
                ? hotelIngredient.displayText
                : hasDisplayText(hotelRelatedIngredient)
                  ? hotelRelatedIngredient.displayText
                  : '',
            hasUserSelectedTransport,
            previousIngredientDestination,
            mainPolygonFullName,
          })
        : getTripOverviewSimpleTransportSegment({
            ingredient,
            hotelRelatedIngredient,
            calculatedRoute,
            isLastSegment: false,
          });

    return transportSegment;
  }
}
